import axios from '../axiosApi'

const initialState = {
  species: []
}

export default {
  state: { ...initialState },
  mutations: {
    setDataSpecies(state, data) {
      state.species = data
    }
  },
  actions: {
    requestDataSpeciesName({ commit, dispatch }, name) {
      axios(`/plants/filter?search=${name}`)
        .then(res => res.data.map(el => ({ id: el.id, name: el.laName })))
        .then(res => commit('setDataSpecies', res))
        .catch(({ data }) => {
          dispatch(
            'showToast',
            { type: 'warning', message: data.code },
            { root: true }
          )
        })
    },
    requestDataSpecies({ commit, dispatch }, arr) {
      const arrFormat = JSON.stringify(arr.map(el => el.id))
      axios
        .get(`/plants/filter?genus=${arrFormat}`)
        .then(res => res.data.map(el => ({ id: el.id, name: el.laName })))
        .then(res => commit('setDataSpecies', res))
        .catch(({ data }) => {
          dispatch(
            'showToast',
            { type: 'warning', message: data.code },
            { root: true }
          )
        })
    }
  },
  getters: {
    getSpecies(state) {
      return state.species
    }
  }
}
